// extracted by mini-css-extract-plugin
export default {"main":"MarketLink_main__NoXBr","arrow":"MarketLink_arrow__kqbQf","text":"MarketLink_text__iNoG2","button":"MarketLink_button__iKup+","actions":"MarketLink_actions__+o29K"};